/**
 * Feature flag names used in Unleash.
 * Add new flags here as constants to ensure consistency across the app.
 */
export const FEATURE_FLAGS = {
  SUBMIT_EXCESS_CONTRIBUTION_PP: 'submit_excess_contribution_pp',
  RECEIPTS_FULL_FLOW: 'ai.receipts.full-flow',
  USE_MY_MONEY_REIMBURSEMENT: 'ai.use-my-money.reimbursement',
  USE_MY_MONEY_SAVED_RECEIPTS: 'ai.use-my-money.saved-receipts',
  USE_MY_MONEY_HSA_WITHDRAWAL: 'ai.use-my-money.hsa-withdrawal',
  CARD_PURSE_LOCK_BY_HEALTH_PLAN: 'integration.card-purse.lock-by-health-plan',
  RETURNED_CHECKS: 'ai.lockbox.returned-checks',
} as const;

export type FeatureFlagName = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
